import modal from "./components/modal";
import {createAvatar} from "@dicebear/avatars";
import * as style from "@dicebear/avatars-bottts-sprites";
import popup from "./components/popup";
import Socket from "./game/Socket";
import {numberTrim, postData, updateModel} from './components/helpers';
import GlobalVars from "./GlobalVars.js";


const {compareTo} = require('js-big-decimal');

class UserMgr {

    users = [];
    currentUser=null;
    sector;
    fraction_id;
    isAuth;
    initialized = false;
    balanceAnimated=true;

    constructor(isAuth) {
        this.showInfo = this.showInfo.bind(this);
        this.setInfo = this.setInfo.bind(this);
        this.newLevel = this.newLevel.bind(this);
        this.setBalances = this.setBalances.bind(this);
        this.updateCurrentUser = this.updateCurrentUser.bind(this);

        this.init = this.init.bind(this);
        this.isAuth = isAuth;

        // Создает дубль запроса, поэтому нельзя включать
        // $(window).on("pageshow", this.init);


        // $("window").on("ready pageshow",async function(event){
        //     if (this.isAuth) {
        //         await this.init();
        //     }
        // })
    }

    async init() {

        if (!this.isAuth) {
            return;
        }

        // Если из кеша достали, то перезагрузим
        // if (e && e.persisted) {
        //     window.location.reload();
        // }

        // if (this.initialized)
        //     return;
        //
        // this.initialized = true;

        Socket.bindAction('userInfo', this.setInfo);
        Socket.bindAction('newLevel', this.newLevel);
        Socket.bindAction('setBalances', this.setBalances);
        Socket.bindAction('updateUser', this.updateCurrentUser);

        const urlParams = new URLSearchParams(window.location.search);
        const dropToken = urlParams.get('dropToken');
        if (dropToken) {
            sessionStorage.removeItem('token');
        }

        await this.loadCurrentUser();
    }

    canWatchDeposits() {

        if (!this.currentUser || this.currentUser.telegram_id == null) {
            return true;
        }

        return false;

    }

    async getCurrentUser() {
        if (!this.currentUser) {
            await this.loadCurrentUser();
        }

        return this.currentUser;
    }


    async loadCurrentUser() {

        const result = await postData(config.server_url + '/user/login');

        if (result && result.status == 'ok') {

            if (result.user) {
                this.setUser(result.user);
                this.currentUser.inventory = result.inventory;
            }

            if (result.balances)
                this.setBalances(result.balances, true)

            // this.sector = result.sector;

            if (result.sector && GlobalVars.sectorInfo) {
                GlobalVars.sectorInfo.update(result.sector);
            }

        } else {
            popup.error('Network problem, reload in 4 sec');
            setTimeout(() => {
                window.location.reload()
            }, 4000);
        }
    }

    openHexes4Demo() {
        setTimeout(() => {
            locationMgr.dblClickForSelectedHexes(0);
        }, 500);

        setTimeout(() => {
            locationMgr.dblClickForSelectedHexes(1);
        }, 1000);

        setTimeout(() => {
            locationMgr.dblClickForSelectedHexes(3);
        }, 1500);

        setTimeout(() => {
            locationMgr.dblClickForSelectedHexes(5);
        }, 2000);
    }

    setUser(user) {
        GlobalVars.currentUser = user;
        this.currentUser = GlobalVars.currentUser;
        if (GlobalVars.UserStat)
            GlobalVars.UserStat.init();



        this.setLevel(user.level);
        this.setFraction(user.fraction_id);
        this.users[user.id] = user;
    }

    updateCurrentUser(data) {
        updateModel(this.currentUser, data);
    }

    setFraction(fraction_id) {
        this.fraction_id = fraction_id;
        const fraction = this.getFraction();
        if (fraction)
            document.documentElement.style.setProperty("--fraction-materia-icon", `url(${fraction.icon})`)
    }

    isUserAllowAction(action) {
        if (!config.user.levels[this.currentUser.level]?.actions)
            return true;

        return config.user.levels[this.currentUser.level].actions.includes(action);
    }

    checkUserAllowAction(action) {

        if (!this.isUserAllowAction(action)) {
            modal.info(__("insufficient level"), __("You level is not enough for this action."), '#insufficientLevel');
            return false;
        }
        return true;

    }

    initUserLevel() {

        for (let i = 1; i <= this.currentUser.level; i++) {
            document.documentElement.style.setProperty("--level" + i + "-display", "inherit");
            document.documentElement.style.setProperty("--only-level" + i + "-display", "none")
        }

        document.documentElement.style.setProperty("--only-level" + this.currentUser.level + "-display", "inherit")

        if (this.currentUser.level > 5) {
            $('.levelProgress').hide();
        } else {
            $('.levelProgress').show();
        }
    }

    getLevel() {
        return this.currentUser.level;
    }

    setLevel(level) {
        this.currentUser.level = level;
        this.initUserLevel();
        $('.level').text(level);

        // if (level == 2) {
        //     ym(90541370,'reachGoal','level2');
        // }
        //
        // if (level == 7) {
        //     ym(90541370,'reachGoal','level7')
        // }
    }


    setSkills(skills) {
        this.currentUser.skills = skills;
    }

    getSkill(skillId) {
        return this.currentUser.skills[skillId];
    }


    setBalances(data, silent = false) {
        let n =0;
        for (let [id, value] of Object.entries(data)) {
            if (!silent && this.balanceAnimated && Object.values(data).length > 1) {
                id = parseInt(id);

                const oldVal = GlobalVars?.balance?.balances[id];
                if (!oldVal || Math.abs(oldVal-value)>0) {

                    setTimeout(() => {
                        this.setBalance(value, id, silent);
                    }, n);
                    n += 150;
                }
            } else {
                this.setBalance(value, parseInt(id), silent);
            }
        }
    }

    setBalance = function (val, resourceId = 3, silent = false) {

        if (!GlobalVars?.balance)
            return;

        const currency = config.currencies[resourceId];
        const resource = currency.name;
        const oldVal = GlobalVars.balance.balances[resourceId];

        GlobalVars.balance.set(resourceId, val);

        if (silent) {
            $('.balance-' + resource).text(val);
            return;
        }

        let resourceIcon = currency.img;
        if (resource == 'materia') {
            const fraction = this.getFraction();
            resourceIcon = '/img/currencies/'+fraction.name+'.webp';
        }

        val = numberTrim(val);

        let className='green';
        let diff = val - oldVal;
        if (diff > 0) {
            diff = '+' + diff;
            popup.onmap(diff + ' <img src="' + resourceIcon + '" width="20px">', className)
        } else if (diff < 0) {
            className = 'red';
            popup.onmap(diff + ' <img src="' + resourceIcon + '" width="20px">', className)
        }


        //popup.success(diff+' coins');

        if (compareTo(oldVal, val) != 0) {

            //$('.balance-' + resource).text(val);
            $('.balance-' + resource).animate({
                'font-size': '20px'
            }, 200, function () {
                $('.balance-' + resource).animate({
                    'font-size': '16px'
                }, 200);
            });
        }
    }

    newLevel(data) {
        this.setLevel(data);
        modal.info(__('Level up!'), __("Congratulations! You have reached level") + " " + data + '!');
    }

    async showInfo(e) {

        const obj = e.currentTarget;
        const user_id = $(obj).data('user_id');

        const user = await this.get(user_id);
        modal.info(user.name, false, '#userInfo', {
            '.rank': config.user.ranks[user.rank_id],
            '.level': user.level,
            '.faction': this.getUserFraction(user).name,
            '.hex_discovered': user.hex_discovered,
            '.hex_captured': user.hex_captured
        });

        const avatarContainer = $('#modal .icon');
        const el = createAvatar(style, {
            seed: user.avatar_hash
        });
        avatarContainer.html(el);
    }

    getFraction() {
        return window.config.fractions[this.fraction_id];
    }
    getFractionIcon() {
        const fraction = this.getFraction();
        return '/img/currencies/' + fraction.name + '.webp';
    }

    getUserFraction(user) {
        return window.config.fractions[user.fraction_id];
    }

    incUserProp(prop, amount = 1) {
        this.setUserProp(prop, this.currentUser[prop] + amount);
    }

    setUserProp(prop, value) {
        this.currentUser[prop] = value;
        // $(`.${prop}`).text(value);
    }

    async get(id) {

        if (this.users[id])
            return this.users[id];

        const result = await postData(`${config.server_url}/user/info`, {
            user_id: id
        });

        if (result && result.status == 'ok') {
            this.users[id] = result.user;
            return this.users[id];
        } else {
            return false;
        }
    }

    setInfo(params) {
        if (GlobalVars.sectorInfo)
            GlobalVars.sectorInfo.update(params);
    }

}

const instance = new UserMgr(window.isAuth);
export default instance;
